/**
 * WalkAndPunch API
 * This is the WalkAndPunch API
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { FileChunkViewModel } from '../model/fileChunkViewModel';
import { TemplateProjectDownloadViewModel } from '../model/templateProjectDownloadViewModel';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class DownloadService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param templateProjectDownloadId 
     * @param chunkNumber 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public downloadChunkProcess(templateProjectDownloadId?: number, chunkNumber?: number, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public downloadChunkProcess(templateProjectDownloadId?: number, chunkNumber?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public downloadChunkProcess(templateProjectDownloadId?: number, chunkNumber?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public downloadChunkProcess(templateProjectDownloadId?: number, chunkNumber?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (templateProjectDownloadId !== undefined && templateProjectDownloadId !== null) {
            queryParameters = queryParameters.set('templateProjectDownloadId', <any>templateProjectDownloadId);
        }
        if (chunkNumber !== undefined && chunkNumber !== null) {
            queryParameters = queryParameters.set('chunkNumber', <any>chunkNumber);
        }

        let headers = this.defaultHeaders;

        // authentication (oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request('get',`${this.basePath}/v1/Download/DownloadChunk`,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param templateProjectDownloadId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTemplateProjectDownloadById(templateProjectDownloadId: number, observe?: 'body', reportProgress?: boolean): Observable<TemplateProjectDownloadViewModel>;
    public getTemplateProjectDownloadById(templateProjectDownloadId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TemplateProjectDownloadViewModel>>;
    public getTemplateProjectDownloadById(templateProjectDownloadId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TemplateProjectDownloadViewModel>>;
    public getTemplateProjectDownloadById(templateProjectDownloadId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (templateProjectDownloadId === null || templateProjectDownloadId === undefined) {
            throw new Error('Required parameter templateProjectDownloadId was null or undefined when calling getTemplateProjectDownloadById.');
        }

        let headers = this.defaultHeaders;

        // authentication (oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<TemplateProjectDownloadViewModel>('get',`${this.basePath}/v1/Download/${encodeURIComponent(String(templateProjectDownloadId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param templateProjectDownloadId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public totalChunk(templateProjectDownloadId?: number, observe?: 'body', reportProgress?: boolean): Observable<FileChunkViewModel>;
    public totalChunk(templateProjectDownloadId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<FileChunkViewModel>>;
    public totalChunk(templateProjectDownloadId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<FileChunkViewModel>>;
    public totalChunk(templateProjectDownloadId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (templateProjectDownloadId !== undefined && templateProjectDownloadId !== null) {
            queryParameters = queryParameters.set('templateProjectDownloadId', <any>templateProjectDownloadId);
        }

        let headers = this.defaultHeaders;

        // authentication (oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<FileChunkViewModel>('get',`${this.basePath}/v1/Download/TotalChunk`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param templateProjectDownloadId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userDownload(templateProjectDownloadId: number, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public userDownload(templateProjectDownloadId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public userDownload(templateProjectDownloadId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public userDownload(templateProjectDownloadId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (templateProjectDownloadId === null || templateProjectDownloadId === undefined) {
            throw new Error('Required parameter templateProjectDownloadId was null or undefined when calling userDownload.');
        }

        let headers = this.defaultHeaders;

        // authentication (oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request('get',`${this.basePath}/v1/Download/userDownload/${encodeURIComponent(String(templateProjectDownloadId))}`,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userDownloads(observe?: 'body', reportProgress?: boolean): Observable<Array<TemplateProjectDownloadViewModel>>;
    public userDownloads(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TemplateProjectDownloadViewModel>>>;
    public userDownloads(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TemplateProjectDownloadViewModel>>>;
    public userDownloads(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<TemplateProjectDownloadViewModel>>('get',`${this.basePath}/v1/Download/userDownloads`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
